module.exports = __webpack_public_path__ + "static/media/daily.94159a49.png";